export default __webpack_public_path__ + "static/dappradar-11b921994a42808b1c8701cca94d492c.jpg";